import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.product-slider__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          focus: 'center',
          arrows: true,
          gap: '20px',
          perPage: 4,
          paginationKeyboard: true,
          drag: true,
          pagination: false,
          start: 1,
          breakpoints: {
            768: {
              perPage: 1,
              arrows: false,
            },
          },
        } );
        slider.mount();
        if ( $( '.tabbed-products__tab-button' ).length ) {
          $( '.tabbed-products__tab-button' ).on( 'click', function() {
            slider.refresh();
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'product-slider', COMPONENT );
} )( app );
